<template>
  <div>
    <el-menu
      v-if="!shouldHideLayout"
      :default-active="activeIndex"
      background-color="#FFFFFF"
      text-color="#5c5c5c"
      active-text-color="#0077c2"
      router
      class="nav-background"
      mode="horizontal"
      :collapse="isCollapse"
      @select="handleSelect"
      @open="handleOpen"
      @close="handleClose"
    >
      <div class="logo-wrapper">
        <!--                <img alt="Vue logo" src="../assets/ldcx-logo-2.png" style="width: 180px; margin-top: 20px">-->
        <!-- 加载中显示 loading -->
        <div v-if="isLogoLoading" class="logo-loading">
          <i class="el-icon-loading" />
        </div>
        <!-- 加载完成显示图片 -->
        <img v-else-if="displayLogo" :src="displayLogo" alt="logo" class="logo-img" @error="handleLogoError">
      </div>

      <!-- 遍历菜单路由 -->
      <template v-for="route in menuRoutes">
        <!-- 如果有子路由，渲染子菜单 -->
        <el-submenu
          v-if="route.children && route.children.length > 0"
          :key="route.path"
          :index="route.fullPath"
        >
          <template slot="title">
            {{ route.name }}
          </template>
          <!-- 递归渲染子菜单 -->
          <template v-for="child in route.children">
            <el-submenu
              v-if="child.children && child.children.length > 0"
              :key="`submenu-${child.path}`"
              :index="child.fullPath"
            >
              <template slot="title">
                {{ child.name }}
              </template>
              <el-menu-item
                v-for="grandChild in child.children"
                :key="grandChild.path"
                :index="grandChild.fullPath"
              >
                {{ grandChild.name }}
              </el-menu-item>
            </el-submenu>
            <el-menu-item
              v-else
              :key="`item-${child.path}`"
              :index="child.fullPath"
            >
              {{ child.name }}
            </el-menu-item>
          </template>
        </el-submenu>
        <!-- 如果没有子路由，直接渲染菜单项 -->
        <el-menu-item
          v-else
          :key="`menu-${route.path}`"
          :index="route.fullPath"
        >
          {{ route.name }}
        </el-menu-item>
      </template>

      <div v-if="isLoggedIn" class="right-menu">
        <div style="cursor: pointer; margin-right: 22px" @click="goNotice">
          <el-badge :value="notifyCount" :hidden="notifyCount <= 0" :max="99" class="item">
            <i class="el-icon-bell" style="font-size: 20px" />
          </el-badge>
        </div>

        <el-popover
          v-model="isPopoverVisible"
          placement="bottom-end"
          width="250"
          trigger="hover"
        >
          <div class="popover-menu">
            <div v-if="isAdmin" @click="goAdmin">
              <i class="el-icon-s-platform" style="font-size: 15px; margin-right: 5px" /> 管理数据
            </div>
            <div @click="goToRoute('/personalinformation')">
              <i class="el-icon-user" style="font-size: 15px; margin-right: 5px" />  个人信息
            </div>
            <!--            <div @click="goToRoute('/school')">-->
            <!--              <i class="el-icon-s-order" style="font-size: 15px; margin-right: 5px" /> 我的证书-->
            <!--            </div>-->
            <!--            <div @click="goToRoute('/teacher')">-->
            <!--              <i class="el-icon-s-claim" style="font-size: 15px; margin-right: 5px" /> 我的实验-->
            <!--            </div>-->
            <!--            <div @click="goToRoute('/school')">-->
            <!--              <i class="el-icon-data-analysis" style="font-size: 15px; margin-right: 5px" /> 岗位能力地图-->
            <!--            </div>-->

            <span class="line" />

            <div @click="logout">
              <i class="el-icon-right" style="font-size: 15px; margin-right: 5px" /> 退出登录
            </div>
          </div>
          <div
            slot="reference"
            class="right-menu-btn"
          >
            <div>
              <img
                alt="Vue logo"
                :src="userDatas.avatarUrl || require('@/assets/defaultAvatar.png')"
                style="width: 43px;height: 43px; border-radius: 50%; margin-right: 10px;object-fit: cover;"
              >
            </div>
            <div class="right-menu-name">
              {{ userDatas.userName }}
            </div>
          </div>
        </el-popover>
      </div>
      <div v-else class="right-menu">
        <el-button type="text" @click="goToRoute('/login')">
          登录
        </el-button>
      </div>
    </el-menu>

    <router-view />

    <Bottom v-if="!shouldHideLayout && !shouldHideBottom" :personalization-data="personalizationData" />

    <!-- 通知组件 -->
    <Notify ref="notify" />
  </div>
</template>
<script>
import {mapGetters, mapState} from "vuex";
import {getToken, removeToken} from "@/utils/auth";
import Bottom from "@/components/Layouts/Bottom/index.vue";
import {logoutApi} from "@/api/login";
import store from "@/store";
import {getNotifyCount} from "@/api/user";
import Notify from "@/layout/notify.vue";

export default {
  name: "TopNav",
  components: {
    Bottom,
    Notify
  },
  data() {
    return {
      notifyCount: 0,
      // currentEnv: currentEnv,
      // 是否登录
      isLoggedIn: false,
      isCollapse: false,
      // 控制弹出框的显示状态
      isPopoverVisible: false,
      // 当前激活的菜单项
      activeIndex: "",
      userData: {},
    };
  },
  watch: {
    $route: {
      handler(to) {
        const path = to.path;
        // 匹配类似 /course/courseindex 或 /simulation/simulationindex 的路径
        if (path.startsWith("/course/")) {
          this.activeIndex = "/course";
        } else if (path.startsWith("/simulation/")) {
          this.activeIndex = "/simulation";
        } else {
          this.activeIndex = path;
        }
      },
      // 组件重建时（如从 /login 跳回详情页）也要按当前路由初始化高亮
      immediate: true,
    },
    // 监听路由数据变化
    routes: {
      handler(newRoutes) {
        console.log('路由数据变化:', newRoutes);
        // 当路由数据变化时，更新登录状态
        this.updateLoginStatus();
      },
      immediate: true
    },
    // 监听个性化配置数据变化，更新网站标题
    personalizationData: {
      handler(newData) {
        if (newData && newData.websiteTitle) {
          document.title = newData.websiteTitle;
        }
      },
      immediate: true,
      deep: true
    }
  },
  // mounted() {
  //   this.$watch("$route", this.updateActiveIndex);
  //   // this.updateActiveIndex(); // 初始化时也设置一次
  // },
  // mounted() {
  //   // 如果页面刷新或首次进入，确保动态路由已经加载
  //   if (!this.routes.length) {
  //     this.$store.dispatch("menu/generateRoutes");
  //   }
  //   // 监听路由变化，动态更新登录状态
  //   this.$watch("$route", this.updateLoginStatus);
  // },
  computed: {
    ...mapState("route", ["routes"]),
    ...mapState("user", ["user", "roles"]),
    ...mapGetters("personalization", ["personalizationData", "displayLogo", "isLogoLoading"]),
    menuRoutes() {
      return this.routes;
    },
    userDatas() {
      return this.user;
    },
    // 是否隐藏布局（顶部导航和底部）
    shouldHideLayout() {
      return this.$route.meta && this.$route.meta.noLayout === true;
    },
    // 是否只隐藏底部
    shouldHideBottom() {
      return this.$route.meta && this.$route.meta.hideBottom === true;
    },
    // 判断用户是否为管理员
    isAdmin() {
      // 检查用户角色中是否包含管理员角色
      // 假设管理员角色标识为 'admin' 或者角色ID为1等
      if (!this.roles || this.roles.length === 0) {
        return false;
      }

      // 根据角色标识判断是否为管理员
      return this.roles.some(role => {
        // 可以根据实际的角色标识进行调整
        // 常见的管理员标识：admin、administrator、ROLE_ADMIN等
        return role === 'admin' ||
               role === 'sys_admin' ||
               role === 'teacher' ||
               role === 'teaching_assistant';
      });
    },
    // isFullScreenPage() {
    //   return this.$route.meta && this.$route.meta.fullScreen;
    // },
  },
  created() {
    this.updateLoginStatus(); // 初始化时更新登录状态
    // 加载个性化配置数据（登录后显示 TopNav 时加载）
    // watch 会自动监听 personalizationData 变化并更新标题，无需手动更新
    this.$store.dispatch("personalization/loadPersonalizationData");
    // console.log("TopNav created - 路由数据:", this.routes);
    // console.log("TopNav created - 登录状态:", this.isLoggedIn);
    this.fetchNotifyCount()
  },
  methods: {
    fetchNotifyCount() {
      getNotifyCount()
        .then((res) => {
          // 兼容不同返回结构：可能是 { code, data } 或直接为数值
          if (res && typeof res.data === 'number') {
            this.notifyCount = res.data
          } else if (typeof res === 'number') {
            this.notifyCount = res
          } else {
            this.notifyCount = 0
          }
        })
        .catch(() => {
          this.notifyCount = 0
        })
    },
    // updateActiveIndex() {
    //   const path = this.$route.path;
    //   if (path.startsWith("/course/")) {
    //     this.activeIndex = "/course";
    //   } else if (path.startsWith("/simulation/")) {
    //     this.activeIndex = "/simulation";
    //   } else {
    //     this.activeIndex = path;
    //   }
    // },
    handleSelect(key) {
      console.log("handleSelect===>", key);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    goToRoute(path) {
      this.isPopoverVisible = false;
      // 跳转到指定路由
      this.$router.push(path);
    },
    goNotice() {
      // 打开通知抽屉
      this.$refs.notify.drawer = true;
    },
    logout() {
      this.$confirm("确定注销并退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        logoutApi().then(() => {
          store.commit('route/RESET_ROUTES');
          removeToken();
          // this.$router.push("/home");
          this.$router.push("/");
          window.location.reload()
          this.isLoggedIn = false;
        });
      });
    },
    // 添加一个方法用于更新登录状态
    updateLoginStatus() {
      this.isLoggedIn = !!getToken();
    },
    // goAdmin() {
    //   const currentEnv = process.env.NODE_ENV;
    //   if (currentEnv === "development") {
    //     window.location.href = 'http://localhost:8088/index';
    //   } else {
    //     window.location.href = '/admin/';
    //   }
    // },

    goAdmin() {
      const currentEnv = process.env.NODE_ENV;
      if (currentEnv === "development") {
        window.open('http://localhost:8088/index', '_blank');
      } else {
        window.open('/admin/', '_blank');
      }
    },
    // 处理 Logo 图片加载失败
    handleLogoError(event) {
      // 如果图片加载失败，显示默认图片
      event.target.src = require("@/assets/logo-2.png");
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-background {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 60px;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
}

.logo-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 58px;
  width: 180px;

  .el-icon-loading {
    font-size: 24px;
    color: #0077c2;
    animation: rotating 2s linear infinite;
  }
}

@keyframes rotating {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.logo-img {
  max-height: 58px; /* 控制在导航高度内，留一点上下间距 */
  //max-width: 200px;
  width: auto;
  height: auto;
  object-fit: contain; /* 按比例缩放，完整显示 */
  display: block;
}

.el-menu {
  border: none;
  margin: 0;
  list-style: none;
  border-bottom: solid 1px #e6e6e6;

  /* 强制显示子菜单 */
  ::v-deep .el-submenu {
    position: relative;

    .el-submenu__title {
      padding: 0 20px;
    }

    .el-submenu__icon-arrow {
      display: none;
    }

    .el-menu {
      position: absolute;
      top: 100%;
      left: 0;
      z-index: 100;
      display: none;
      min-width: 200px;
      background: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }

    &:hover .el-menu {
      display: block;
    }

    .el-menu-item {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      position: relative;

      &::before {
        content: '';
        position: absolute;
        bottom: 0;
        left: 0;
        width: 0;
        height: 3px;
        background: linear-gradient(90deg, #0077c2, #00a8e8);
        transition: width 0.3s ease-in-out;
      }

      &:hover::before {
        width: 100%;
      }
    }
  }

  ::v-deep .el-menu-item {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 0;
      height: 2px;
      background: #4578cb;
      transition: width 0.3s ease-in-out;
    }

    &:hover::before {
      width: 100%;
    }

    background-color: transparent !important;
  }

  /* 激活状态样式 */
  ::v-deep .el-menu-item.is-active {
    border-bottom: 2px solid #4578cb !important;
    color: #303133 !important;
  }

  ::v-deep .el-submenu.is-active .el-submenu__title {
    border-bottom: 2px solid #4578cb !important;
  }

  ::v-deep .el-submenu__title:hover {
    background-color: transparent !important; // 移除鼠标悬停背景色
  }

  //::v-deep .el-submenu__title {
  //  position: relative;
  //
  //  &::before {
  //    content: '';
  //    position: absolute;
  //    bottom: -2px;
  //    left: 0;
  //    width: 0;
  //    height: 2px;
  //    background: #4578cb;
  //    transition: width 0.3s ease-in-out;
  //  }
  //
  //  &:hover::before {
  //    width: 100%;
  //  }
  //
  //  background-color: transparent !important;
  //}
}

//.line {
//  width: 100%;
//  height: 1px;
//  background-color: #bcbcbc;
//  display: inline-block;
//  margin: 10px 0;
//}


.right-menu {
  display: flex;
  align-items: center;
  cursor: pointer;

  .right-menu-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    //padding-top: 15px;
    .right-menu-name {
      font-size: 14px;
      font-weight: bold;
      color: #333;
    }
  }
}

.popover-menu {
  div {
    padding: 10px;
    cursor: pointer;

    &:hover {
      background-color: #f0f0f0;
    }
  }
}
</style>
